export default {"src":"/_next/static/media/mail-icon.d54fc3fe.svg","height":10,"width":14,"blurWidth":0,"blurHeight":0};